module.exports = __webpack_public_path__ + "img/logo_new.91ccb446.svg";